import React from 'react';
import * as cls from './reviews.module.css';
import { Typography } from '../../../ui/components/typography/typography';
import { IMG_PATH } from '../../../constants';
import { CarouselHalf } from '../../components/carousel-half';

const items = [
  {
    name: 'Chris',
    title: 'Clever, Accurate, and Great for Sub-Metering',
    text: '"We installed Voltaware to monitor energy usage in our garden annexe, and it does the job perfectly - tracking both total consumption and individual appliances. While setup took a bit of care (especially with WiFi), the included instructions were excellent and easy to follow. It\'s not exactly plug-and-play, but if you follow the steps, it’s straightforward. A very clever device - even better than I expected."',
  },
  {
    name: 'Steve H',
    title: 'A Big Step Up from Plug-in Monitors',
    text: '"I returned a plug-in energy monitor because it only tracked one device and lost data when unplugged. Voltaware is a far better solution — more powerful, and likely to pay for itself in 6 months. The app has a bit of a learning curve, but it’s already helping me identify background consumption and hidden energy drains. I’ve reduced standby usage from 150W to just 18W. It’s insightful, detailed, and genuinely useful for cutting waste."',
  },
  {
    name: 'Michael',
    title: 'Great App, Accurate Insights Over Time',
    text: '"I’ve been using the Voltaware sensor in my flat for four months. Setup was easy, and while accuracy improved over time, it’s now very impressive. The updated app is excellent — offering clear real-time and historical energy data with appliance-level insights. A very good tool for understanding home energy use."',
  },
  {
    name: 'Mattia Spolladore',
    title: 'Easy Setup and Excellent Performance',
    text: '"Installation was quick, straightforward, and user-friendly. Being able to instantly track and understand my home’s energy usage makes it a valuable addition. Highly recommended!"',
  },
  {
    name: 'Mica',
    title: 'Simple, Reliable, and Informative',
    text: '"The setup was super simple - installed the sensor, downloaded the app, and connected it to Wi-Fi without any issues. Real-time energy monitoring is fantastic -I see changes instantly when switching appliances on. A great tool to understand and manage energy consumption."',
  },
  {
    name: 'Lynne Baldwin',
    title: 'Reduced Bills, Greater Control',
    text: '"Voltaware identified costly standby appliances and helped reduce our bills significantly. It’s invaluable for seeing exactly where our energy - and money- is going."',
  },
];

export const Reviews = ({ shouldAnimate = true }) => {
  return (
    <CarouselHalf className={cls.carousel}>
      {items.map((item, index) => (
        <div className={cls.item} key={index}>
          <Typography as="p" tag="h3">
            {item.title}
          </Typography>
          <div>
            <img
              src={`${IMG_PATH}/ico-star.svg`}
              alt="voltaware 5 stars review"
            />
            <img
              src={`${IMG_PATH}/ico-star.svg`}
              alt="voltaware 5 stars review"
            />
            <img
              src={`${IMG_PATH}/ico-star.svg`}
              alt="voltaware 5 stars review"
            />
            <img
              src={`${IMG_PATH}/ico-star.svg`}
              alt="voltaware 5 stars review"
            />
            <img
              src={`${IMG_PATH}/ico-star.svg`}
              alt="voltaware 5 stars review"
            />
          </div>
          <Typography>{item.text}</Typography>
          <Typography>{item.name}</Typography>
        </div>
      ))}
    </CarouselHalf>
  );
};
